import { type JSX } from 'react'
import type { MemoLine } from '@/shared/templates/memos/lib/renderMemo'

/**
 * One preview line as the created memo will carry it.
 *
 * The title is the one heading a memo of ours has, and is shown as the heading
 * it will be. Everything the memo writes below it is plain body text - a block
 * heading, a section subheading and a day divide it by standing on lines of
 * their own rather than by being formatted. Only a line lifted out of an
 * inserted PM can arrive as a heading or in bold, and it is shown as what it
 * will be saved as.
 */
export const PreviewLine = ({ line }: {
  line: MemoLine
}): JSX.Element => {
  if (line.role === 'heading-1') {
    return (
      <h4 className='whitespace-pre-wrap text-base font-bold'>
        {line.text}
      </h4>
    )
  }

  if (line.role === 'heading-2') {
    return (
      <h5 className='whitespace-pre-wrap font-semibold pt-2'>
        {line.text}
      </h5>
    )
  }

  if (line.bold) {
    return (
      <p className='whitespace-pre-wrap font-bold pt-2'>
        {line.text}
      </p>
    )
  }

  return <p className='whitespace-pre-wrap'>{line.text}</p>
}
